module.exports = __webpack_public_path__ + "img/girl-right.dffd6788.png";